import { render, staticRenderFns } from "./IssuedCertificate.vue?vue&type=template&id=703f5dda&scoped=true"
import script from "./IssuedCertificate.vue?vue&type=script&lang=js"
export * from "./IssuedCertificate.vue?vue&type=script&lang=js"
import style0 from "./IssuedCertificate.vue?vue&type=style&index=0&id=703f5dda&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f5dda",
  null
  
)

export default component.exports